import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import PhoneKeypad from "./PhoneKeypad_V";

import LanguageButtons from "./../Shared/LanguageButtons";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import BackspaceIcon from "@mui/icons-material/Backspace";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import KioskStepper from "./../../Components/Stepper/KioskStepper_V";
import Logo from "./../../Components/Logo_V";

import { useTheme, createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import { getErrorTranslateID } from "./../../HelperFunctions/ErrorDisplayFunctions";

import formatFirstNameLastInitial from "./../../HelperFunctions/formatFirstNameLastInitial";
import formatAddress from "./../../HelperFunctions/formatAddress";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal_V";

import { WORKFLOW_MODES } from "../../../../constants";
let env = require("./../../../../env");

export default function VerticalLayout(props) {
  const {
    overrideCode,
    setOverrideCodeFunc,
    nextFunc,
    loading,
    errorCode,
    clearErrorFunc,
    isNotMobile,
    kioskkey,
    workflowmode,
    getKioskConfiguration
  } = props;

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const [locationAddress, setLocationAddress] = useState("");
  const [locationName, setLocationName] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const kioskConfig = getKioskConfiguration();

    if (kioskConfig == undefined || kioskConfig == null) {
      return navigate("/errorscreen");
    }

    setLocationAddress(kioskConfig.locationAddress);
    setLocationName(kioskConfig.locationName);
  }, []);

  const theme = useTheme();

  const kioskverticalstyles_2 = useKioskVerticalStyles();

  const vtheme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              height: "8vh",
              width: "46vw",
              fontSize: "6vh"
            }
          }),
          input: ({ ownerState }) => ({
            ...{
              textAlign: "center"
            }
          })
        }
      }
    }
  });

  const backspacepress = event => {
    if (overrideCode.length > 0) {
      setOverrideCodeFunc(overrideCode.substring(0, overrideCode.length - 1));
    }
  };

  return (
    <div style={kioskverticalstyles_2.flexBackground}>
      <div style={kioskverticalstyles_2.logo}>
        <center>
          <Logo />
        </center>
      </div>

      <div style={kioskverticalstyles_2.instructionDiv}>
        <div style={kioskverticalstyles_2.instructionVerticallyAlignDiv}>
          <Translate
            value="application.theme.wizardWelcomeText"
            name={formatFirstNameLastInitial(
              customerFirstName,
              customerLastName
            )}
          />
          <br />
          <Translate
            value="application.theme.wizardAddressText"
            name={locationName}
            address={formatAddress(locationAddress)}
          />
          .<br />
          <Translate value="application.kioskdetail.returning" />
          <b>
            <Translate
              value="application.kioskdetail.numbags"
              count={numBags}
            />
            .
          </b>
        </div>
      </div>

      <div
        style={{
          ...kioskverticalstyles_2.whiteDiv,
          ...kioskverticalstyles_2.flexcenterDiv
        }}
      >
        <div style={kioskverticalstyles_2.configuration.whitecontentdiv}>
          <div
            class="fontSecondaryText"
            style={{
              textAlign: "center",
              marginBottom: "2vh"
            }}
          >
            <div
              style={{
                fontSize: "3vh",
                fontWeight: "500",
                marginBottom: "1vh"
              }}
            >
              <Translate value="application.theme.SubmissionApprovalTitleText" />
            </div>
            <div style={{ fontSize: "2vh", color: "red" }}>
              <Translate
                value="application.theme.SubmissionApprovalInstructionText"
                count={numBags}
              />
            </div>
          </div>

          <center>
            <ThemeProvider theme={vtheme}>
              <TextField
                id="KioskApprovalKey"
                label=""
                type="password"
                value={overrideCode}
                style={{
                  marginBottom: "3vh"
                }}
                onChange={event => {
                  let newText = event.target.value;
                  newText = newText.toUpperCase().trim();
                  setOverrideCodeFunc(newText);
                }}
                inputProps={{
                  readOnly: true,
                  style: { cursor: "pointer" } // Optional: keeps the cursor visible
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          backspacepress();
                        }}
                        edge="end"
                      >
                        <BackspaceIcon style={{ fontSize: "3.8vh" }} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white"
                  }
                }}
              />
            </ThemeProvider>
            <PhoneKeypad
              phonenumber={overrideCode}
              setPhonenumber={setOverrideCodeFunc}
              keypadDone={nextFunc}
              loading={loading}
              errorMessage={""}
              clearErrorFunc={clearErrorFunc}
              //showconfirmdialog={showconfirmdialog}
            />
          </center>
          <div style={kioskverticalstyles_2.configuration.buttoncontainer}>
            <div style={kioskverticalstyles_2.configuration.buttondiv}>
              {/* DEBUG BUTTONS */}
              {/* <Button
                variant="contained"
                disabled={loading}
                //onClick={navigatePrinterDebug}
                style={{ marginBottom: "3vh" }}
              >
                <span className="fontSecondaryText">
                  <Translate value="application.configuration.printerdebug" />
                </span>
              </Button> */}
              {/* END DEBUG BUTTONS */}

              {/* <Button
                fullWidth
                variant="contained"
                disabled={loading}
                onClick={nextFunc}
                style={{
                  ...kioskverticalstyles_2.configuration.nextbutton,
                  marginTop: "1vh",
                  height: "5vh"
                }}
              >
                <span className="fontSecondaryText">
                  <Translate value="application.next" />
                </span>
              </Button> */}
            </div>
          </div>
          <div>
            <Typography
              variant="body2"
              className="fontSecondaryText"
              style={{
                color: "red",
                marginTop: theme.spacing(0.5),
                fontSize: "2vh",
                textAlign: "center"
              }}
            >
              <Translate value={getErrorTranslateID(errorCode)} />
            </Typography>
          </div>
        </div>
      </div>
      <div style={kioskverticalstyles_2.footerDiv}>
        <KioskStepper
          activeStep={1}
          backUrl={"/numbags"}
          workflowmode={workflowmode}
          getKioskConfiguration={getKioskConfiguration}
        />
      </div>
      <PrinterConnectionModal />
    </div>
  );
}
